import React, {useEffect} from 'react';
import PDFObject from 'pdfobject';

export default function PDFPreviewer(props) {

  useEffect(() => {
    PDFObject.embed(props.fileSrc, '#pdf-viewer');
  }, []);

  return <div id="pdf-viewer" style={props.style}></div>;
}
